import { SHOW_LOADER, HIDE_LOADER, LoaderActionTypes } from "./loader.types";

export const loaderShow = (): LoaderActionTypes => ({
  type: SHOW_LOADER,
});

export const loaderHide = (): LoaderActionTypes => ({
  type: HIDE_LOADER,
});
